module.exports = __webpack_public_path__ + "static/media/check.9216751f.svg";